import axios from 'axios';
import authHeader from './auth-header';

const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/Feature/Doc`;

class DocService {
  getDocCoverPageDownload(loanNumber, docCoverPage) {
    return axios.post(`${API_URL}/DocCoverPageDownload?loanNumber=${loanNumber}`,
    docCoverPage,
    {
      headers: authHeader() 
    })
    .then(response => {
      return response;
    });
  }
}

export default new DocService();